module.exports = __webpack_public_path__ + "static/media/hsbc_logo_en.c54203b0.svg";